/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateEmail.defs.js'
export * as $defs from './updateEmail.defs.js'
